import { FormattedMessage } from 'react-intl';
import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { Spacer } from 'ech-components/src/helpers';
import { mixins, text } from 'ech-components/src/core/styles/theme/default';

const StyledNoResults = styled.div`
  ${text.lead1};
  text-align: center;
`;

const StyledNoResultsIcon = styled.div`
  width: ${rem(100)};
  height: ${rem(100)};
  margin: 0 auto;
  background: url("data:image/svg+xml,%3Csvg width='80' height='80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle opacity='.5' cx='40' cy='40' r='40' fill='%23FFD59C'/%3E%3Cpath d='M60.5 60.5l-9-9M36.5 52.5c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16z' stroke='%235F013D' stroke-width='2' stroke-miterlimit='10' stroke-linecap='square'/%3E%3Cpath d='M26.5 36.5a10 10 0 0110-10' stroke='url(%23paint0_linear)' stroke-width='2' stroke-miterlimit='10'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='26.5' y1='26.5' x2='38.566' y2='31.234' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FFAD38'/%3E%3Cstop offset='1' stop-color='%23FFAD38'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E")
    no-repeat center / 100%;

  ${mixins.MQ('medium')} {
    width: ${rem(160)};
    height: ${rem(160)};
  }
`;

const NoResults = ({
  searchResults,
}: {
  searchResults: { nbHits: number; query: string };
}) => (
  <>
    {searchResults?.nbHits === 0 ? (
      <StyledNoResults>
        <StyledNoResultsIcon />
        <Spacer space="theta" />
        <FormattedMessage
          id="search.noResults"
          values={{ query: searchResults.query }}
        />
        <Spacer space="lambda" />
      </StyledNoResults>
    ) : null}
  </>
);

export default NoResults;
